import api from './api';

export interface AssetComparisonItem {
  name: string;
  s3Key?: string;
  s3Size?: number;
  s3LastModified?: string;
  rangeosUuid?: string;
  rangeosName?: string;
  status: 'matched' | 'in_s3_only' | 'in_rangeos_only';
}

export interface AssetTypeComparison {
  assetType: string;
  label: string;
  s3Prefix: string;
  s3Count: number;
  rangeosCount: number;
  matched: number;
  inS3Only: number;
  inRangeOSOnly: number;
  items: AssetComparisonItem[];
}

export interface ValidationResult {
  endpointId: string;
  endpointName: string;
  s3Branch: string;
  timestamp: string;
  assetTypes: AssetTypeComparison[];
  summary: {
    totalS3: number;
    totalRangeOS: number;
    totalMatched: number;
    totalS3Only: number;
    totalRangeOSOnly: number;
  };
}

export interface S3Structure {
  branches: string[];
  projects: Record<string, string[]>;
}

export const assetValidationApi = {
  discoverS3Structure: async (): Promise<S3Structure> => {
    const { data } = await api.get<S3Structure>('/asset-validation/s3-structure');
    return data;
  },

  validate: async (endpointId: string, s3Branch?: string, s3Project?: string): Promise<ValidationResult> => {
    const { data } = await api.post<ValidationResult>('/asset-validation/validate', {
      endpointId,
      s3Branch,
      s3Project,
    });
    return data;
  },
};
